import {Controller} from 'stimulus';

export default class extends Controller {
  static targets = ["langWrapper", "syncButton"];
  static values = { lang: String, mainLang: String };

  changeLanguage(event) {
    event.preventDefault();
    this.langValue = event.currentTarget.dataset.lang;
  }

  langValueChanged() {
    let $this = this;
    $this.langWrapperTargets.forEach(element => {
      element.hidden = element.dataset.lang !== this.langValue;
    });

    // Mostra/nascondi i pulsanti di sincronizzazione
    if (this.hasSyncButtonTarget) {
      this.syncButtonTargets.forEach((button) => {
        if ($this.langValue === $this.mainLangValue) {
          button.classList.add('hidden');
        } else {
          button.classList.remove('hidden');
        }
      });
    }
  }

  async translateFromMainLang(event) {
    event.preventDefault();
    event.stopPropagation();

    const confirmed = confirm(event.currentTarget.dataset.confirm);
    if (!confirmed) return;

    // Se siamo già nella lingua principale non fare nulla
    if (this.langValue === this.mainLangValue) {
      return;
    }

    // Mostra il loader
    document.getElementById('loading-overlay').classList.add('active');

    // Ottiene il blocco specifico se fornito nell'evento
    const specificSection = event.currentTarget.closest('[data-translation-section]');
    let currentLangWrappers = [];

    // Trova tutti gli elementi traducibili nella lingua corrente
    if(specificSection) {
      const sectionValue = specificSection.dataset.translationSection;

      currentLangWrappers = this.langWrapperTargets.filter(
        wrapper => wrapper.dataset.lang === this.langValue && !wrapper.hidden &&
        wrapper.closest(`[data-translation-section="${sectionValue}"]`) !== null
      )
    } else {
      currentLangWrappers = this.langWrapperTargets.filter(
        wrapper => wrapper.dataset.lang === this.langValue && !wrapper.hidden
      )
    }

    const totalItems = currentLangWrappers.length;
    const progressElement = document.getElementById('loading-overlay__progress-wrapper');

    let itemIndex = 1;
    for (const wrapper of currentLangWrappers) {
      // Seleziona solo input e textarea con gli attributi richiesti
      const targetItem = wrapper.querySelector('input[data-translatable="true"][data-lang="'+this.langValue+'"], textarea[data-translatable="true"][data-lang="'+this.langValue+'"]');
      if(targetItem) {
        this.scrollToItem(targetItem);
        await this.translateItemContent(targetItem);
      }

      // Update progress
      progressElement.textContent = `${itemIndex}/${totalItems}`;
      itemIndex++;
    }

    // Nasconde il loader
    document.getElementById('loading-overlay').classList.remove('active');
  }

  async translateItemContent(item) {
    const mainItemId = item.getAttribute('data-main-lang-field-id');
    const mainItem = document.getElementById(mainItemId);

    if (mainItem) {
      const mainContent = mainItem.value;
      await this.aiTranslation(mainContent, item);
    }
  }

  async aiTranslation(mainContent, item) {
    const response = await fetch('/admin/ai-translation/translate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({
        content: mainContent,
        source_lang: this.mainLangValue,
        target_lang: this.langValue
      })
    });

    if (!response.ok) {
      throw new Error(response.statusText);
    }

    const data = await response.json();

    item.value = data.translated_content;

    if (item.dataset.controller && item.dataset.controller.includes('mediumeditor-component')) {
      item.dispatchEvent(new CustomEvent('content-sync', {
        detail: {content: data.translated_content},
        bubbles: true
      }));
    }

    if(item.dataset.sluggerizeTarget && item.dataset.sluggerizeTarget === 'input') {
      const event = new Event('input', { bubbles: true });
      item.dispatchEvent(event);
    }

  }

  scrollToItem(item) {
    const targetPosition = item.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }
}
